import { apiClient, omrehBaseClient } from "./client";

const GetAll = () => {
  return omrehBaseClient
    .get("/Station");
}

const GetByKey = (id) => {
  return apiClient
    .get("/Station/GetByKey", {
      params: {
        'Id': id
      }
    });
}

const FlightStationDropDown = () => {
  return apiClient
    .get("/Station/FlightStationDropDown");
}

const GetForUser = () => {
  return omrehBaseClient
    .get("/Station/GetForUser");
}

const stationApi = { GetAll, GetByKey, FlightStationDropDown, GetForUser }
export default stationApi;